import { render, staticRenderFns } from "./AllowancesPlansTable.vue?vue&type=template&id=c076d360&"
import script from "./AllowancesPlansTable.vue?vue&type=script&lang=js&"
export * from "./AllowancesPlansTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports